<template>
  <div class="paging flex justify-between items-center border-t border-solid pt-4" v-if="pagingData.lastPage > 1">
    <p
      class="text-sm poppins"
    >Showing {{ pagingData.from }} to {{ pagingData.to }} of {{ pagingData.total }} results</p>

    <div class="flex">
      <router-link
        :to="{ path: path, query: { ...queryString, page: 1 } }"
        v-if="pagingData.currentPage > 1"
      >
        <font-awesome-icon :icon="['fas', 'angle-double-left']" size="sm" />
      </router-link>
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage - 1 } }"
        v-if="pagingData.currentPage > 1"
        href="#"
      >
        <font-awesome-icon :icon="['fas', 'angle-left']" size="sm" />
      </router-link>

      <!-- previous page -->
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage - 2 } }"
        v-if="pagingData.currentPage - 2 > 0"
      >{{ pagingData.currentPage - 2 }}</router-link>
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage - 1 } }"
        v-if="pagingData.currentPage - 1 > 0"
      >{{ pagingData.currentPage - 1 }}</router-link>
      <!-- current page -->
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage } }"
        class="active"
        href="#"
      >{{ pagingData.currentPage }}</router-link>

      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage + 1 } }"
        v-if="pagingData.currentPage + 1 <= pagingData.lastPage"
      >{{ pagingData.currentPage + 1 }}</router-link>
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage + 2 } }"
        v-if="pagingData.currentPage + 2 <= pagingData.lastPage"
      >{{ pagingData.currentPage + 2 }}</router-link>

      <!-- next page -->
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.currentPage + 1 } }"
        v-if="pagingData.currentPage < pagingData.lastPage"
      >
        <font-awesome-icon :icon="['fas', 'angle-right']" size="sm" />
      </router-link>
      <router-link
        :to="{ path: path, query: { ...queryString, page: pagingData.lastPage } }"
        v-if="pagingData.currentPage < pagingData.lastPage"
      >
        <font-awesome-icon :icon="['fas', 'angle-double-right']" size="sm" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePaging",
  props: {
    queryString: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
    },
    path: {
      type: String,
      required: true,
    },
    pagingData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.paging {
  a {
    @apply h-8 w-8 items-center justify-center flex border bg-gray-300 rounded-md border-0 transition-colors duration-100 text-sm;
    font-family: "Poppins", sans-serif;

    &.active,
    &:hover {
      @apply bg-blue-500 text-white;
    }

    &:not(:last-child) {
      @apply mr-2;
    }
  }
}
</style>
